if ($(".Surface").length) {
  $(".Surface").slick({
    slidesToShow:1,
    slidesToScroll:1,
    arrows: false,
    fade:false,
    dots:true,
    infinite: false,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9.104" height="16.208" viewBox="0 0 9.104 16.208"><path id="Path_318" data-name="Path 318" d="M1423.787,401.185l6.69,6.69-6.69,6.69" transform="translate(1431.477 415.979) rotate(180)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9.104" height="16.208" viewBox="0 0 9.104 16.208"><path id="Path_318" data-name="Path 318" d="M1423.787,401.185l6.69,6.69-6.69,6.69" transform="translate(-1422.373 -399.771)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg></button>',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows: false
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows: false
        }
      }
    ]
  });
}
if ($(".Wide").length) {
  $(".Wide").slick({
    slidesToShow:1,
    slidesToScroll:1,
    arrows: false,
    fade:false,
    dots:true,
    infinite: false,
    // appendDots:'.Wide__subdot',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9.104" height="16.208" viewBox="0 0 9.104 16.208"><path id="Path_318" data-name="Path 318" d="M1423.787,401.185l6.69,6.69-6.69,6.69" transform="translate(1431.477 415.979) rotate(180)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9.104" height="16.208" viewBox="0 0 9.104 16.208"><path id="Path_318" data-name="Path 318" d="M1423.787,401.185l6.69,6.69-6.69,6.69" transform="translate(-1422.373 -399.771)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg></button>',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows: false
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows: false
        }
      }
    ]
  });
}
// var activeClass = 'slick-active',
//     ariaAttribute = 'aria-hidden';
// $( '.Wide' )
// .on( 'init', function() {
//     $( '.slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
// } )
// .on( 'afterChange', function( event, slick, currentSlide ) {
//     var $dots = $( '.slick-dots' );
//     $( 'li', $dots ).removeClass( activeClass ).attr( ariaAttribute, true );
//     $dots.each( function() {
//         $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
//     } );
// } );

// $( '.Wide' ).slick();